import { create } from 'zustand';

export interface ThirdPartyHeaderStore {
	isThirdPartyShowHeader: boolean;
	setIsThirdPartyShowHeader: (value: boolean) => void;
}

export const useThirdPartyHeaderStore = create<ThirdPartyHeaderStore>(set => ({
	isThirdPartyShowHeader: true,
	setIsThirdPartyShowHeader: (value: boolean) => set({ isThirdPartyShowHeader: value }),
}));

export const getIsThirdPartyShowHeader = (): boolean =>
	useThirdPartyHeaderStore.getState().isThirdPartyShowHeader;

export const setIsThirdPartyShowHeader = (value: boolean): void => {
	useThirdPartyHeaderStore.getState().setIsThirdPartyShowHeader(value);
};
